import { ICompany } from './common/company.model';
import { IGenericModel } from './common/generic-model.model';
import { IGroup } from './common/group.model';
import { Lang } from '../lang/language.service';

export interface IUser extends IGenericModel {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  company?: ICompany;
  companies?: ICompany[];
  username?: string;
  bio?: string;
  image?: string;
  idpUid?: string;
  accountValidated?: boolean;
  invitationDate?: Date;
  userRole?: UserRole;
  csm?: boolean;
  group?: IGroup;
  memberId?: number;
  locale?: Lang;
  isSso?: boolean;
}

export class IOnboardingData {
  companyActivities?: string[];
  hubspotId?: number;
  companyName?: string;
  email?: string;
  phone?: string;
  firstname?: string;
  lastname?: string;
  idpUid?: string;
  locale?: Lang;
}

export enum UserRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  USER = 'USER',
}
